import { call } from 'app/utils/function';
import { matchAll, substitute } from 'app/utils/string';
const Empty = Symbol('ga-cb--Empty');
const NotFound = Symbol('ga-cb--NotFound');
let ga = Empty;
function prepareCallback() {
    const analyticsFnc = configGet('analyticsCallback', '_track.push("send","event","Editor")');
    const analyticsFncRegex = /^([^(]+)(\(([^)]*)\))?/gm;
    const analyticsMatch = analyticsFncRegex.exec(analyticsFnc);
    if (!analyticsMatch) {
        return -1;
    }
    const [, cmdStr, , paramsStr] = analyticsMatch;
    if (!cmdStr) {
        return -2;
    }
    const cmd = cmdStr.split('.').filter(part => part && part.length > 0);
    if (!cmd.length) {
        return -3;
    }
    const defaultParams = [];
    if (paramsStr) {
        const paramsRegex = /["']([a-zA-Z0-9-]+)["']/gm;
        matchAll(paramsStr, paramsRegex, ([, match]) => defaultParams.push(match));
    }
    let obj = window;
    while (obj && cmd.length > 1) {
        obj = obj[cmd.shift()];
    }
    if (!obj) {
        return -4;
    }
    const fnc = obj[cmd[0]];
    if (typeof fnc !== 'function') {
        return -5;
    }
    ga = (...params) => {
        const args = [undefined, undefined, ...params].map((value, index) => value !== null && value !== void 0 ? value : defaultParams[index]);
        fnc.apply(obj, args);
    };
    return 0;
}
function logEvent(event) {
    getLogger('analytics', 'debug')(substitute('Event: category="{category}", action="{action}", label="{label}", value="{value}"', event));
}
export function analytics(event) {
    var _a;
    const hasAnalytics = hasFeature('analytics');
    if (!hasAnalytics) {
        const pikej = configGet('pikej', false);
        if (pikej) {
            logEvent(event);
        }
        return;
    }
    if (ga === Empty) {
        ga = NotFound;
        const result = prepareCallback();
        if (result < 0) {
            // error
            getLogger('analytics', 'error')(`Failed to create analytics callback. Code=${result}`);
        }
    }
    if (ga === NotFound) {
        logEvent(event);
        return;
    }
    call(ga, event.category, event.action, event.label, (_a = event.value) === null || _a === void 0 ? void 0 : _a.toString());
}
